import { useEffect, useMemo, useState } from "react"
import EsfirusSelect from "@components/ui/Select/EsfirusSelect"
import { getRequest, postRequest } from "@screens/Backoffice/utils/requests"
import moment from "moment"
import ModalConfirmar from "./ModalConfirmar"
import EsfirusButtonNative from "@components/ui/Button/EsfirusButtonNative"

const QAManagement = () => {
  // Carga de ramas.
  const [loadingBranches, setLoadingBranches] = useState(true)
  const [apiBranches, setApiBranches] = useState([])
  const [frontBranches, setFrontBranches] = useState([])

  // Carga de dockers.
  const [loadingDockers, setLoadingDockers] = useState(true)
  const [dockers, setDockers] = useState([])

  // Ramas seleccionadas.
  const [apiBranchSelected, setApiBranchSelected] = useState("")
  const [frontBranchSelected, setFrontBranchSelected] = useState("")

  // Cliente seleccionado.
  const [clientSelected, setClientSelected] = useState("")

  // Estados de actualización de clientes.
  const [loadingSettingBranch, setLoadingSettingBranch] = useState(false)
  const [settingBranchFinished, setSettingBranchFinished] = useState(false)
  const [settingBranchFailed, setSettingBranchFailed] = useState(false)
  const [showModalConfirm, setShowModalConfirm] = useState(false)

  useEffect(() => {
    fetchBranches()
    fetchDockers()
  }, [])

  const fetchBranches = async () => {
    setLoadingBranches(true)
    try {
      const ramasResponse = await getRequest("modules/sas/server/branches")
      const ramasApi = ramasResponse?.data?.apiBranches ?? []
      const ramasFront = ramasResponse?.data?.frontBranches ?? []
      setApiBranches(ramasApi)
      setFrontBranches(ramasFront)
    } catch (error) {
      setApiBranches([])
      setFrontBranches([])
    } finally {
      setLoadingBranches(false)
    }
  }

  const fetchDockers = async () => {
    setLoadingDockers(true)
    try {
      const clientesResponse = await getRequest('modules/sas/dockers/list')
      const clientes = (clientesResponse?.data ?? []).map(cliente => (cliente.name))
      setDockers(clientes)
    } catch (error) {
      setDockers([])
    } finally {
      setLoadingDockers(false)
    }
  }

  const setterBranch = async () => {
    setLoadingSettingBranch(true)
    try {
      await postRequest('modules/sas/server/build-qa', { apiBranch: apiBranchSelected, frontBranches: frontBranchSelected, client: clientSelected })
    } catch (error) {
      setSettingBranchFailed(true)
    } finally {
      setLoadingSettingBranch(false)
      setSettingBranchFinished(true)
    }
  }

  return (
    <div className="update-clients-wrapper">
      <EsfirusSelect
        style={{ maxWidth: "350px" }}
        options={apiBranches.map(build => ({ value: build, label: build }))}
        change={(e) => setApiBranchSelected(e)}
        disabled={loadingBranches}
        value={apiBranchSelected}
        fill={Boolean(apiBranchSelected)}
        placeholder="Seleccionar la rama API"
      />
      <EsfirusSelect
        style={{ maxWidth: "350px" }}
        options={frontBranches.map(build => ({ value: build, label: build }))}
        change={(e) => setFrontBranchSelected(e)}
        disabled={loadingBranches}
        value={frontBranchSelected}
        fill={Boolean(frontBranchSelected)}
        placeholder="Seleccionar la rama FRONT"
      />
      <EsfirusSelect
        style={{ maxWidth: "350px" }}
        options={dockers.map(docker => ({ value: docker, label: docker }))}
        change={(e) => setClientSelected(e)}
        disabled={loadingDockers}
        value={clientSelected}
        fill={Boolean(clientSelected)}
        placeholder="Seleccionar el cliente a levantar"
      />
      <div className="update-qa-buttons-wrapper">
        <EsfirusButtonNative
          click={() => {
            if (!apiBranchSelected || apiBranchSelected === "") {
              alert("Selecciona la rama API que necesitas testear.")
              return
            }

            if (!frontBranchSelected || frontBranchSelected === "") {
              alert("Selecciona la rama FRONT que necesitas testear.")
              return
            }

            if (!clientSelected || clientSelected === "") {
              alert("Selecciona el cliente a levantar.")
              return
            }

            setShowModalConfirm(true)
          }}
          label="Construir entorno QA"
        />
      </div>

      {/* Modal de confirmación de creación de nueva build */}
      {showModalConfirm && (
        <ModalConfirmar
          title="Construcción de entorno QA"
          open={setShowModalConfirm}
          onClose={() => {
            setShowModalConfirm(false)
            setLoadingSettingBranch(false)
            setSettingBranchFinished(false)
            setSettingBranchFailed(false)
          }}
          initialText={`¿Estás seguro de que la rama API: ${apiBranchSelected} y FRONT: ${frontBranchSelected} son los correctos?`}
          loading={loadingSettingBranch}
          msgLoading="Construyendo entorno QA..."
          finished={settingBranchFinished}
          msgFinished="Entorno de QA construido correctamente."
          failed={settingBranchFailed}
          msgFailed="Algo ha salido mal en la construcción, vuelve a intentarlo en unos minutos."
          action={async () => await setterBranch()}
        />
      )}
    </div>
  )
}

export default QAManagement